/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M10 6.6 8.6 8", key: "itrr7k" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "M15 7.5 9.5 13", key: "1vyrsv" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }]
];
const MirrorRound = createLucideIcon("mirror-round", __iconNode);

export { __iconNode, MirrorRound as default };
//# sourceMappingURL=mirror-round.js.map
